export const commandMenuShortcuts = {
    adminSettings: ['a'],
    searchContacts: ['c'],
    analyticsAndReports: ['r'],
    settings: ['s'],
    showUnreadActivities: ['u'],
    help: ['?']
}
